import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function useBoosterProjectSetting() {
  const client = useApiClientUser()

  async function fetchBoosterProjectSetting() {
    return client.user
      .settingsControllerGetBoosterProject({ secure: true })
      .then((res) => res.data.data)
  }

  const { data: boosterProjectSetting } = useQuery({
    queryKey: ['boosterProjectSetting'],
    queryFn: fetchBoosterProjectSetting,
  })

  return {
    isAvailable: boosterProjectSetting?.isAvailable ?? false,
  }
}

export { useBoosterProjectSetting }
